import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-user-activation',
  templateUrl: './user-activation.component.html',
  styleUrls: ['./user-activation.component.scss'],
})
export class UserActivationComponent implements OnInit {
  message: any;
  isProcess: boolean = true;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {}
  isActivate;
  isSuccess;
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      console.log(params);
      this.validateUserLink(params);
    });
  }
  validateUserLink(params) {
    let body = {
      activeUUID: params?.id,
      activeFlag: 1,
    };
    this.http.put('/security/user-activation', body).subscribe(
      (res) => {
        console.log(res);
        this.isActivate = true;
        this.isSuccess = res['data'][1];
        this.message = res['data'][0];
        this.isProcess = false;
      },
      (err) => {
        console.log(err);
        this.isActivate = false;
        this.isSuccess = false;
        this.isProcess = false;
      }
    );
  }
  onLogin() {
    console.log('login');
    this.router.navigateByUrl('/login');
  }
}
